import { useState } from "react";
import { Link } from "react-router-dom";
import { logout, resendVerification } from "../lib/auth-actions";

export function VerifyEmail() {
  const [sent, setSent] = useState(false);

  return (
    <div className="mx-auto mt-16 w-full max-w-sm fade-up">
      <div className="glass neon-border rounded-2xl p-7 text-center">
        <h1 className="neon-text text-xl font-bold">이메일 인증</h1>
        <p className="mt-4 text-sm text-slate-300">
          가입하신 이메일로 인증 링크를 보냈습니다. 인증을 완료한 뒤 다시 로그인해주세요.
        </p>
        <button
          type="button"
          onClick={async () => {
            await resendVerification();
            setSent(true);
          }}
          className="btn-neon mt-5 w-full rounded-lg py-2.5 text-sm font-semibold"
        >
          {sent ? "메일을 다시 보냈습니다" : "인증 메일 재전송"}
        </button>
        <p className="mt-4 text-center text-xs text-slate-500">
          <Link
            to="/login"
            onClick={() => void logout()}
            className="transition hover:text-cyan-300"
          >
            로그인 화면으로
          </Link>
        </p>
      </div>
    </div>
  );
}
